import * as types from '../../../../../constants/ActionNameConstants';

// Proofreader cga files
export const cgaFilesRequest = (payload) => ({
  type: types.GET_CGA_FILES_LIST_REQUEST,
  payload,
});

export const cgaFilesSuccess = (payload) => ({
  type: types.GET_CGA_FILES_LIST_SUCCESS,
  payload,
});

export const cgaFilesFailure = (error) => ({
  type: types.GET_CGA_FILES_LIST_FAILED,
  error,
});

export const mergeCGAFileCollectionDownloadRequest = (payload) => ({
  type: types.MERGE_CGA_FILE_COLLECTION_DOWNLOAD_REQUEST,
  payload,
});

export const mergeCGAFileCollectionDownloadSuccess = (payload) => ({
  type: types.MERGE_CGA_FILE_COLLECTION_DOWNLOAD_SUCCESS,
  payload,
});

export const mergeCGAFileCollectionDownloadFailure = (error) => ({
  type: types.MERGE_CGA_FILE_COLLECTION_DOWNLOAD_FAILED,
  error,
});

export const saveFileMergeStatusCGARequest = (payload) => ({
  type: types.SAVE_FILE_MERGE_STATUS_CGA_REQUEST,
  payload,
});

export const saveFileMergeStatusCGASuccess = (payload) => ({
  type: types.SAVE_FILE_MERGE_STATUS_CGA_SUCCESS,
  payload,
});

export const saveFileMergeStatusCGAFailure = (error) => ({
  type: types.SAVE_FILE_MERGE_STATUS_CGA_FAILED,
  error,
});

export const updateCGAFileStates = (payload) => ({
  type: types.UPDATE_CGA_FILE_STATES,
  payload,
});

export const resetCGAFileStates = () => ({
  type: types.RESET_CGA_FILE_STATES,
});

export const cgaClientListRequest = () => ({
  type: types.GET_CGA_CLIENT_LIST_REQUEST,
});

export const cgaClientListSuccess = (payload) => ({
  type: types.GET_CGA_CLIENT_LIST_SUCCESS,
  payload,
});

export const cgaClientListFailure = (error) => ({
  type: types.GET_CGA_CLIENT_LIST_FAILED,
  error,
});